import { useTranslation } from 'react-i18next';

/** Klaviatura bilan birinchi Tab: menyudan o'tmasdan asosiy matnga */
export function SkipLink() {
  const { t } = useTranslation();
  return (
    <a
      href="#main"
      className="btn btn-primary sr-only px-4 py-2 text-sm focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[70]"
    >
      {t('a11y.skipToContent')}
    </a>
  );
}
